import React, { useState, useEffect, useRef } from "react";
import "./Login.css";

const images = [
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  // All images will now be SignIn.png
];

const Login = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageClass, setImageClass] = useState('');
  const [selectedUserType, setSelectedUserType] = useState('doctor');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageClass('slide-out');
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setImageClass('slide-in');
      }, 500); // Half of transition duration
    }, 2000); // Change image every 2 seconds
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    if (index !== currentImageIndex) {
      setImageClass('slide-out');
      setTimeout(() => {
        setCurrentImageIndex(index);
        setImageClass('slide-in');
      }, 500); // Half of transition duration
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleUserTypeChange = (type) => {
    setSelectedUserType(type);
  };

  return (
    <div className="signin-signup-container">
      <div className="left-panel">
        <h1>Log in to your account</h1>
        <p>to access smarter healthcare, secure records, and<br />AI-powered assistance — all in one place.</p>
        <div className="image-carousel">
          <img src={images[currentImageIndex]} alt="Sign In" className={imageClass} />
          <div className="carousel-dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
      <div className="right-panel">
        <div className="form-container">
          <div className="form-header">
            <img src="/images/GenixLogo.png" alt="Genix Logo" className="genix-logo" />
            <div className="user-type-toggle-group">
              <div
                className={`toggle-button ${selectedUserType === 'doctor' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('doctor')}
              >
                Doctor
              </div>
              <div
                className={`toggle-button ${selectedUserType === 'patient' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('patient')}
              >
                Patient
              </div>
              <div
                className={`toggle-button ${selectedUserType === 'admin' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('admin')}
              >
                Admin
              </div>
            </div>
          </div>
          <h2>Welcome Back</h2>
          <p>Don't have an account? <a href="/signup">Sign up</a></p>
          <form>
            <input type="email" placeholder="E-mail *" />
            <div className="password-field">
              <input 
                type={showPassword ? "text" : "password"} 
                placeholder="Password *" 
              />
              <span 
                className="password-toggle" 
                onClick={togglePasswordVisibility}
              >
                {showPassword ? "👁️‍🗨️" : "👁️"}
              </span>
            </div>
            <div className="form-footer">
              <div className="remember-me">
                <input type="checkbox" id="remember" />
                <label htmlFor="remember">Remember me</label>
              </div>
              <a href="#" className="forgot-password">Forgot Password?</a>
            </div>
            <button type="submit">Sign In</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login; 